// extracted by mini-css-extract-plugin
export default {"orden":"TablaTorneoEtapas_orden__79mCp","etapa":"TablaTorneoEtapas_etapa__uyzs+","tipo":"TablaTorneoEtapas_tipo__YPVj1"};